import Layout from 'antd/lib/layout/layout';
import { OrderTableView } from './components/OrderTableView';

export const OrderPageViewNew = () => {
  return (
    <Layout
      style={{
        height: 'calc(100vh - 32px)',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >
      <OrderTableView />
    </Layout>
  );
};
